// ---------------------------------------------------------------------------
// Button Renderer
// ---------------------------------------------------------------------------
// Foundational primitive — publishes the editor `Button` block as an <a>
// anchor styled as a button. Distinct from `cta-banner`, which is a
// full-width section. Standalone Buttons remain inline-centered.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, url } from "../escape.js";

type ButtonVariant = "primary" | "secondary" | "outline";

interface ButtonProps {
  label?: string;
  url?: string;
  variant?: ButtonVariant | string;
}

const VALID_VARIANTS: ReadonlySet<ButtonVariant> = new Set([
  "primary",
  "secondary",
  "outline",
]);

function resolveVariant(value: unknown): ButtonVariant {
  if (typeof value === "string" && VALID_VARIANTS.has(value as ButtonVariant)) {
    return value as ButtonVariant;
  }
  return "primary";
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as ButtonProps;

  const label = typeof p.label === "string" ? p.label.trim() : "";
  if (!label) {
    return "<!-- button missing label -->";
  }

  const href = typeof p.url === "string" && p.url.trim() ? p.url : "#";
  const variant = resolveVariant(p.variant);

  return `<section class="ease-section ease-button-section" style="text-align: center;">
  <a href="${url(href)}" class="ease-btn ease-btn-${attr(variant)} ease-button" role="button">${text(label)}</a>
</section>`;
}

registerRenderer("button", { render });
